var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-action-bar" },
    [
      _c(
        "CompassTooltip",
        { attrs: { arrow: false } },
        [
          _c("template", { slot: "content" }, [
            _c("span", [_vm._v(_vm._s(_vm.labels.showHistoryTooltip))])
          ]),
          _vm._v(" "),
          _c(
            "span",
            [
              _c("CompassIconButton", {
                attrs: {
                  icon: "history",
                  size: "small",
                  active: _vm.displayHistory
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("toggleHistory")
                  }
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "CompassTooltip",
        { attrs: { arrow: false } },
        [
          _c("template", { slot: "content" }, [
            _c("span", [_vm._v(_vm._s(_vm.pinStatusLabel))])
          ]),
          _vm._v(" "),
          _c(
            "span",
            [
              _c("CompassIconButton", {
                attrs: { icon: "pin", size: "small", active: _vm.isPinned },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.onClickPin($event)
                  }
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm.oneLog.canSee
        ? _c(
            "CompassTooltip",
            { attrs: { arrow: false } },
            [
              _c("template", { slot: "content" }, [
                _c("span", [_vm._v(_vm._s(_vm.labels.seeDetailsTooltip))])
              ]),
              _vm._v(" "),
              _c(
                "span",
                [
                  _c("CompassIconButton", {
                    attrs: { icon: "panel-right-expand", size: "small" },
                    on: {
                      click: function($event) {
                        return _vm.previewElement(_vm.oneLog)
                      }
                    }
                  })
                ],
                1
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { ref: "customTooltip", class: _vm.customTooltipClasses }, [
        _vm._v("\n        " + _vm._s(_vm.labels.moreActionsTooltip) + "\n    ")
      ]),
      _vm._v(" "),
      _vm.canEdit || _vm.canDelete
        ? _c(
            "span",
            [
              _c(
                "CompassMenu",
                {
                  ref: "actionBarMenu",
                  attrs: {
                    size: "small",
                    placement: "top-end",
                    customClass: "container-action-bar__menu",
                    disabled: !_vm.isActionBarVisible
                  }
                },
                [
                  _c("CompassIconButton", {
                    attrs: { icon: "action", size: "small" },
                    on: {
                      click: _vm.handleCustomTooltipVisibility,
                      mouseenter: _vm.handleCustomTooltipVisibility,
                      mouseleave: _vm.handleCustomTooltipVisibility
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "dropdown" },
                    [
                      _vm.canEdit
                        ? _c("CompassMenuItem", {
                            attrs: { label: _vm.labels.menuItemModify },
                            on: {
                              click: function($event) {
                                return _vm.editElement(_vm.oneLog)
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.canDelete
                        ? _c("CompassMenuItem", {
                            attrs: { label: _vm.labels.menuItemDelete },
                            on: {
                              click: function($event) {
                                return _vm.deleteElement(_vm.oneLog)
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }